"use strict";

/*!
   Copyright 2019 Ron Buckton

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

       http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/
var _defineProperty = require("/usr/src/app/node_modules/@babel/runtime/helpers/defineProperty.js");
var _regeneratorRuntime = require("/usr/src/app/node_modules/@babel/runtime/regenerator/index.js");
var _createClass = require("/usr/src/app/node_modules/@babel/runtime/helpers/createClass.js");
var _classCallCheck = require("/usr/src/app/node_modules/@babel/runtime/helpers/classCallCheck.js");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Disposable = void 0;
var utils_js_1 = require("./internal/utils.js");
/**
 * Indicates an object that has resources that can be explicitly disposed.
 */
var Disposable = /*#__PURE__*/_createClass(
/**
 * Creates a `Disposable` wrapper around a callback used to dispose of a resource.
 * @deprecated Use `DisposableStack` or `{ [Disposable.dispose]() { ... } }` instead.
 */
function Disposable(dispose) {
  _classCallCheck(this, Disposable);
  if (!(typeof dispose === "function")) throw new TypeError("Function expected: dispose");
  return Disposable.create(dispose);
});
exports.Disposable = Disposable;
/**
 * Indicates an object that has resources that can be explicitly disposed.
 */
(function (Disposable) {
  var _marked = /*#__PURE__*/_regeneratorRuntime.mark(scope),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(usingEach);
  /**
   * A well-known symbol used to define an explicit resource disposal method on an object.
   *
   * NOTE: Uses `Symbol.dispose` if present.
   */
  Disposable.dispose = typeof Symbol["dispose"] === "symbol" ? Symbol["dispose"] : Symbol.for("@esfx/disposable:Disposable.dispose");
  /**
   * Emulate `using const` using `for..of`.
   *
   * NOTE: This is not spec-compliant and will not be standardized.
   *
   * @example
   * ```ts
   * // with `using const` (proposed)
   * {
   *   ...
   *   using const x = expr, y = expr;
   *   ...
   * }
   *
   * // with `Disposable.scope()`:
   * for (const { using, fail } of Disposable.scope()) {
   *   try {
   *     ...
   *     const x = using(expr), y = using(expr);
   *     ...
   *   }
   *   catch (e) {
   *     fail(e);
   *   }
   * }
   * ```
   */
  function scope() {
    var context;
    return _regeneratorRuntime.wrap(function scope$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            context = (0, utils_js_1.CreateScope)("sync");
            _context.prev = 1;
            context.state = "initialized";
            _context.next = 5;
            return context.scope;
          case 5:
            context.state = "exiting";
          case 6:
            _context.prev = 6;
            context.state = "done";
            (0, utils_js_1.DisposeResources)("sync", context.disposables, context.throwCompletion);
            return _context.finish(6);
          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _marked, null, [[1,, 6, 10]]);
  }
  Disposable.scope = scope;
  /**
   * Yields each disposable in the iterable, disposing it when the generator resumes.
   *
   * This emulates `for (using const x of expr)`.
   *
   * NOTE: This is not spec-compliant and will not be standardized.
   *
   * @example
   * ```ts
   * // with `using const` (proposed)
   * for (using const x of expr) {
   *   ...
   * }
   *
   * // with `Disposable.usingEach()`:
   * for (const x of Disposable.usingEach(expr)) {
   *   ...
   * }
   * ```
   */
  function usingEach(iterable) {
    var _iterator, _step, disposable, _iterator2, _step2, _step2$value, using, fail;
    return _regeneratorRuntime.wrap(function usingEach$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if ((typeof iterable === "object" && iterable !== null || typeof iterable === "function") && Symbol.iterator in iterable) {
              _context2.next = 2;
              break;
            }
            throw new TypeError("Object not iterable: iterable");
          case 2:
            // for (using const disposable of disposables) yield disposable;
            _iterator = _createForOfIteratorHelper(iterable);
            _context2.prev = 3;
            _iterator.s();
          case 5:
            if ((_step = _iterator.n()).done) {
              _context2.next = 32;
              break;
            }
            disposable = _step.value;
            _iterator2 = _createForOfIteratorHelper(Disposable.scope());
            _context2.prev = 8;
            _iterator2.s();
          case 10:
            if ((_step2 = _iterator2.n()).done) {
              _context2.next = 22;
              break;
            }
            _step2$value = _step2.value, using = _step2$value.using, fail = _step2$value.fail;
            _context2.prev = 12;
            _context2.next = 15;
            return using(disposable);
          case 15:
            _context2.next = 20;
            break;
          case 17:
            _context2.prev = 17;
            _context2.t0 = _context2["catch"](12);
            fail(_context2.t0);
          case 20:
            _context2.next = 10;
            break;
          case 22:
            _context2.next = 27;
            break;
          case 24:
            _context2.prev = 24;
            _context2.t1 = _context2["catch"](8);
            _iterator2.e(_context2.t1);
          case 27:
            _context2.prev = 27;
            _iterator2.f();
            return _context2.finish(27);
          case 30:
            _context2.next = 5;
            break;
          case 32:
            _context2.next = 37;
            break;
          case 34:
            _context2.prev = 34;
            _context2.t2 = _context2["catch"](3);
            _iterator.e(_context2.t2);
          case 37:
            _context2.prev = 37;
            _iterator.f();
            return _context2.finish(37);
          case 40:
          case "end":
            return _context2.stop();
        }
      }
    }, _marked2, null, [[3, 34, 37, 40], [8, 24, 27, 30], [12, 17]]);
  }
  Disposable.usingEach = usingEach;
  var disposablePrototype = Disposable.prototype;
  Object.defineProperty(disposablePrototype, Symbol.toStringTag, {
    configurable: true,
    value: "Disposable"
  });
  /**
   * Creates a `Disposable` wrapper around a callback used to dispose of a resource.
   *
   * NOTE: This is not spec-compliant and will not be standardized. It is preferred to use a `DisposableStack`
   * or to implement `Disposable.dispose` yourself instead.
   */
  function create(dispose) {
    if (!(typeof dispose === "function")) throw new TypeError("Function expected: dispose");
    var disposed = false;
    return Object.setPrototypeOf(_defineProperty({}, Disposable.dispose, function () {
      if (!disposed) {
        disposed = true;
        var cb = dispose;
        dispose = undefined;
        cb();
      }
    }), disposablePrototype);
  }
  Disposable.create = create;
  /**
   * Determines whether a value is Disposable.
   *
   * NOTE: This is not spec-compliant and will not be standardized.
   */
  function hasInstance(value) {
    return (typeof value === "object" && value !== null || typeof value === "function") && Disposable.dispose in value;
  }
  Disposable.hasInstance = hasInstance;
})(Disposable = exports.Disposable || (exports.Disposable = {}));
Object.defineProperty(Disposable, Symbol.hasInstance, Object.getOwnPropertyDescriptor(Disposable, "hasInstance"));